import { render, staticRenderFns } from "./RentsPage.vue?vue&type=template&id=002ec6f3&scoped=true"
import script from "./RentsPage.vue?vue&type=script&lang=js"
export * from "./RentsPage.vue?vue&type=script&lang=js"
import style0 from "./RentsPage.vue?vue&type=style&index=0&id=002ec6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002ec6f3",
  null
  
)

export default component.exports